// export type AlertableDevice = IDevice & {
//   role?: string;
// };

export const DeviceTypeToDisplayStringMap: Record<string, string> = {
  Device: 'Any Device',
  Thermostat: 'Thermostat',
  Boiler: 'Boiler',
  Chiller: 'Chiller',
  ConductorGenericSensor: 'Conductor Sensor',
  Controller: 'Controller',
  Loop: 'Loop',
  ModbusAirHandler: 'Air Handler Unit',
  IndoorSensor: 'Temperature/Humidity Sensor',
  // OpenWeather: 'Outside Weather',
  DoorSensor: 'Door Sensor',
  PressureSensor: 'Pressure Sensor',
  Gpio: 'GPIO',
  LeakDetector: 'Leak Detector',
  OccupancySensor: 'Occupancy Sensor',
  OutdoorSensor: 'Outdoor Temperature Sensor',
  SmartPowerOutlet: 'Smart Power Outlet',
  RelayDevice: 'Relay Device',
  Actuator: 'Actuator',
  VsdPump: 'VSD Pump',
  Z210Pump: 'Z210 Pump',
  Thermistor: 'Thermistor',
  WindowSensor: 'Window Sensor',
  IndoorAirHandler: 'Indoor Air Handler',
  PowerMonitor: 'Power Monitor',
  PlmEventResponse: 'PLM Event Response',
  EnergyConsumerBuilding: 'Energy Consumer Building',
  EnergyConsumerTenant: 'Energy Consumer Tenant',
  EnergyConsumerUtility: 'Energy Consumer Utility',
};
